import axios from 'axios'

import { config, keys, platform_name } from "../../../config.env";
import { getStorage } from '../../../lib'

const ENDPOINT_DOMAIN = config.API_ENDPOINT

const baseUrl = ENDPOINT_DOMAIN + "/api/v1"

export const ApiExportExcel = (payload) => {
	return new Promise((resolve) => {
		let config = {
			method: "POST",
			data: payload,
			url: baseUrl + `/export/excel`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiExportPDF = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/microservice/findDocument`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}

		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

